class User {

    constructor(data) {
        // user main data
        this.email = data.email;
        this.token = data.token;
        this.language = 'fr';

        this.isLogged = false;

    }

    // getters
    getEmail() {
        return this.email;
    }

    getToken() {
        return this.token;
    }

    getLanguage() {
        return this.language;
    }

    // setters
    setEmail(email) {
        this.email = email;
    }

    setToken(token) {
        this.token = token;
    }

    setLanguage(lang) {
        this.language = lang;
    }

    isLogged() {
        return this.isLogged;
    }
}

export default User;
